import React from 'react';

import {
  CONTAINER,
  ROW,
  COLUMN,
  ELEMENT,
} from '../element-categories';

import {
  LOGO,
  MENU,
  SOCIAL_MEDIA,
  BUTTON,
  IMAGE,
  SEARCH,
  LANGUAGE_SELECTOR,
  SHOPPING_ICON,
  NAVIGATION,
  DIVIDER,
  TEXTBOX,
} from '../element-types';

import RemoveElement from './RemoveElement';
import styles from '../../../../stylesheet/css/header-builder/options-titlebar.css';

const getTitlebarText = (model) => {
  switch(model.category) {
    case CONTAINER:
      return 'Container options';
    case ROW:
      return 'Row';
    case COLUMN:
      return 'Column options';
    case ELEMENT:
      switch(model.type) {
        case LOGO:
          return 'Logo';
        case MENU:
          return 'Menu options';
        case SOCIAL_MEDIA:
          return 'Social Media options';
        case BUTTON:
          return 'Button options';
        case IMAGE:
          return 'Image options';
        case SEARCH:
          return 'Search options';
        case LANGUAGE_SELECTOR:
          return 'Language options';
        case SHOPPING_ICON:
          return 'Shopping Icon options';
        case NAVIGATION:
          return 'Navigation Menu options';
        case DIVIDER:
          return 'Divider options';
        case TEXTBOX:
          return 'Text Box options';
        default:
          return 'Unknown Element options';
      }
    default:
      return 'Unknown';
  }
};

const OptionsTitlebar = (ownProps) => {
  const {device, highlightedElementModel} = ownProps;
  return (
    <div className={styles.titlebar}>
      {getTitlebarText(highlightedElementModel)}
      <RemoveElement {...ownProps} />
    </div>
  );
};

export default OptionsTitlebar;



// WEBPACK FOOTER //
// ./app/header-builder/components/OptionsTitlebar.js